import { Controller } from "@hotwired/stimulus"

// Row selection for bulk edits on the Plan van aanpak: row boxes, one box per
// group that (de)selects that group, and a bar that appears with the count.
//
//   <div data-controller="bulk-select" data-bulk-select-one-value="%{count} …" data-bulk-select-other-value="…">
//     <input type="checkbox" data-bulk-select-target="group" data-group="overdue" data-action="bulk-select#toggleGroup">
//     <input type="checkbox" data-bulk-select-target="row" data-group="overdue" data-action="bulk-select#update">
//     <div data-bulk-select-target="bar" hidden><span data-bulk-select-target="count"></span> …</div>
export default class extends Controller {
  static targets = ["row", "group", "bar", "count"]
  static values = { one: String, other: String }

  connect() {
    this.update()
  }

  toggleGroup(event) {
    const group = event.target.dataset.group
    for (const row of this.rowTargets) if (row.dataset.group === group) row.checked = event.target.checked
    this.update()
  }

  clear() {
    const first = this.rowTargets.find((row) => row.checked)
    for (const box of [...this.rowTargets, ...this.groupTargets]) box.checked = false
    this.update()
    // The bar hides with the button just pressed: keep keyboard focus in the list.
    ;(first || this.rowTargets[0])?.focus()
  }

  update() {
    const selected = this.rowTargets.filter((row) => row.checked).length
    this.barTarget.hidden = selected === 0
    this.countTarget.textContent = (selected === 1 ? this.oneValue : this.otherValue).replace("%{count}", selected)
    for (const box of this.groupTargets) {
      const rows = this.rowTargets.filter((row) => row.dataset.group === box.dataset.group)
      const checked = rows.filter((row) => row.checked).length
      box.checked = rows.length > 0 && checked === rows.length
      box.indeterminate = checked > 0 && checked < rows.length
    }
  }
}
